import { render, staticRenderFns } from "./m-editKeywordChild.vue?vue&type=template&id=5c091d14&"
import script from "./m-editKeywordChild.vue?vue&type=script&lang=js&"
export * from "./m-editKeywordChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports